import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90f03681"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "type-selector" }
const _hoisted_2 = { class: "type-grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "type-title" }
const _hoisted_5 = { class: "type-desc" }
const _hoisted_6 = {
  key: 0,
  class: "subtype-bar"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtype-title" }, "选择操作类型", -1 /* HOISTED */))
const _hoisted_8 = { class: "subtype-buttons" }
const _hoisted_9 = ["disabled", "title", "onClick"]
const _hoisted_10 = { class: "subtype-icon" }
const _hoisted_11 = { class: "subtype-name" }
const _hoisted_12 = {
  key: 0,
  class: "subtype-tag"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 主类型选择 "),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.typeConfig, (config, type) => {
        return _createElementVNode("div", {
          key: type,
          class: _normalizeClass(["type-card", { active: $setup.modelType === type }]),
          style: _normalizeStyle({ borderColor: $setup.modelType === type ? config.color : 'transparent' }),
          onClick: $event => ($setup.selectType(type))
        }, [
          _createElementVNode("div", {
            class: "type-icon",
            style: _normalizeStyle({ color: config.color })
          }, _toDisplayString(config.icon), 5 /* TEXT, STYLE */),
          _createElementVNode("div", _hoisted_4, _toDisplayString($setup.typeNames[type]), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, _toDisplayString(config.desc), 1 /* TEXT */)
        ], 14 /* CLASS, STYLE, PROPS */, _hoisted_3)
      }), 64 /* STABLE_FRAGMENT */))
    ]),
    _createCommentVNode(" 子类型选择 "),
    ($setup.modelType && $props.showSubtypes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.typeConfig[$setup.modelType].subtypes, (sub) => {
              return (_openBlock(), _createElementBlock("button", {
                key: sub.code,
                class: _normalizeClass(["subtype-btn", { active: $setup.modelSubtype === sub.code, disabled: sub.disabled }]),
                disabled: sub.disabled,
                title: sub.disabled ? '该操作后端尚未实现' : '',
                onClick: $event => ($setup.selectSubtype(sub.code))
              }, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(sub.icon), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_11, _toDisplayString(sub.name), 1 /* TEXT */),
                (sub.disabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "未开放"))
                  : _createCommentVNode("v-if", true)
              ], 10 /* CLASS, PROPS */, _hoisted_9))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}